import { Skeleton as MuiSkeleton, SkeletonProps } from "@mui/material";

interface ISkeletonProps extends SkeletonProps {}

/**
 * Единый скелетон-плейсхолдер под обе темы. В тёмной — светлая
 * полупрозрачная плитка на тёмном фоне, в светлой — тёмный тон
 * на светлом.
 */
export const Skeleton = ({ sx, ...rest }: ISkeletonProps) => {
  return (
    <MuiSkeleton
      animation="wave"
      {...rest}
      sx={[
        (theme) => ({
          bgcolor:
            theme.palette.mode === "dark"
              ? "rgba(255, 255, 255, 0.06)"
              : "rgba(0, 0, 0, 0.06)",
          "&::after": {
            background:
              theme.palette.mode === "dark"
                ? "linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.06), transparent)"
                : "linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.06), transparent)",
          },
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    />
  );
};
